<template>
    <v-row
        no-gutters
        class="pl-9 pt-8"
    >
        <v-col
            cols="12"
            class="pr-10"
            style="word-break: normal"
        >
            <AppStoreListHeader
                :item-count="get(taskButtons, 'length', 0)"
                :item-label="$t('buttons')"
                :add-label="$t('Add')"
                :row-class="''"
                show-button
                @add-item="openButtonDialog(0)"
            />
            <v-row no-gutters style="margin-left: -16px;">
                <v-col cols="12">
                    <v-data-table
                        :headers="headers"
                        :items="taskButtons"
                        :items-per-page="-1"
                        hide-default-footer
                        hide-default-header
                        class="border-bottom"
                    >
                        <template v-slot:header>
                            <thead>
                                <tr>
                                    <th
                                        v-for="(h, i) in headers"
                                        :key="i"
                                        :class="h.class"
                                        class="table-header"
                                    >
                                        <span>{{ h.text }}</span>
                                    </th>
                                </tr>
                            </thead>
                        </template>

                        <template
                            v-if="loading"
                            v-slot:body
                        >
                            <tr
                                v-for="(i, index) in 4"
                                :key="index"
                            >
                                <td
                                    v-for="header in headers"
                                    :key="header.value"
                                >
                                    <v-skeleton-loader
                                        type="list-item"
                                    ></v-skeleton-loader>
                                </td>
                            </tr>
                        </template>

                        <template v-slot:body="{ items }">
                            <draggable
                                :list="taskButtons"
                                tag="tbody"
                                @change="handleOrderChanged"
                            >
                                <tr
                                    v-for="(item, index) in taskButtons"
                                    :key="index"
                                >
                                    <td class="no-border white" style="width: 10px">
                                        <v-img :max-width="10" :src="require('../../../assets/drag-icon.svg')" />
                                    </td>
                                    <td style="width: 36px">{{ item.icon }}</td>
                                    <td>{{ item.description }}</td>
                                    <td style="width: 20%">
                                        <div>
                                            <v-switch
                                                v-model="item.is_visible"
                                                hide-details
                                                :true-value="1"
                                                :false-value="0"
                                                class="ma-0 pa-0"
                                                @change="handleVisibilityChanged(item, $event)"
                                            />
                                        </div>
                                    </td>
                                    <td> {{ item.is_for_everyone ? $t('Everyone') : $t('Only me') }}</td>
                                    <td style="width: 36px" class="pr-0">
                                        <v-btn
                                            v-if="shouldShowEditButton(item)"
                                            icon
                                            @click="openButtonDialog(item.task_id)"
                                        >
                                            <v-icon>edit</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                            </draggable>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
import AppStoreDialogSidebar from "@/components/AppStore/AppStoreDialogSidebar";
import AppModule from "@/store/modules/app";
import { $t } from "@/i18n";
import draggable from "vuedraggable";
import { actions } from "@/store/modules/dialog";
import appStoreDialog from "@/store/modules/AppStoreDialog/appStoreDialog";
import axios from 'axios'
import { computed, ref } from "@vue/composition-api";
import TaskModule from "@/store/modules/task";
import TaskButtonModule from "@/store/modules/task_button";
import AppStoreListHeader from "../../../components/AppStore/AppStoreListHeader";

export default {
    name: "MagicButtonDialogButtonsTab",
    components: {
        AppStoreDialogSidebar,
        draggable,
        AppStoreListHeader
    },
    setup() {
        const { openTask } = TaskModule();
        const { fetchTaskButtons, changeButtonOrder, changeButtonVisibility, taskButtons, setCurrentAccountId } = TaskButtonModule();

        const headers = [
            { text: "", value: "drag_handle", class: 'no-border' },
            { text: $t("Icon"), value: "icon" },
            { text: $t("Name"), value: "name" },
            { text: $t("Show to me"), value: "show_to_me" },
            { text: $t("Visible"), value: "visible" },
            { value: "edit", sortable: false }
        ];

        const { appStoreDialogGetters, appStoreDialogFlags } = appStoreDialog();

        const selectedAccount = computed(() => {
            return appStoreDialogGetters.getSelectedCompany();
        });

        function openButtonDialog(id) {
            openTask(id, { is_task_button: true, company_id: selectedAccount.value.id });
        }

        setCurrentAccountId(selectedAccount.value.id)
        fetchTaskButtons(selectedAccount.value.id)

        function handleOrderChanged(){
            changeButtonOrder(selectedAccount.value.id)
        }
        async function handleVisibilityChanged(item, event){
            await changeButtonVisibility(item.id, event ? 1 : 0 )
        }

        function shouldShowEditButton(item){
            return appStoreDialogFlags.canManageAccount() || !item.is_for_everyone
        }


        return {
            headers,
            openButtonDialog,
            taskButtons,
            handleOrderChanged,
            handleVisibilityChanged,
            shouldShowEditButton
        };
    }
};
</script>

<style scoped>
.no-border {
    border: none !important
}
</style>
